export enum DBType {
	users = "users",
	contacts = "contacts",
	companies = "companies",
	productions = "productions",
	events = "events",
	ips = "ips",
	capabilities = "capabilities",
	capabilityEvents = "capabilityEvents",
	ipEquivalences = "ipEquivalences",
	projects = "projects",
	projectIps = "projectIps",
	certificates = "certificates",
	certificateIPS = "certificateIPS",
	certificateEvents = "certificateEvents",
	capabilityCertificates = "capabilityCertificates",
	documents = "documents",
	capabilityRequests = "capabilityRequests",
	capabilityRequestEvents = "capabilityRequestEvents",
}
